import { Navigate } from 'react-router-dom';
import { useAuth } from 'src/hooks/use-auth';

export const RoleGuard = ({ allowedRoles, allowedSubRoles, children }) => {
  const { user } = useAuth();

  if (!user) {
    return <Navigate to="/401" />;
  }

  if (user.is_super) {
    return children;
  }

  if (allowedRoles && allowedRoles.length > 0 && !allowedRoles.includes(user.role)) {
    return <Navigate to="/401" />;
  }

  if (allowedSubRoles && allowedSubRoles.length > 0 && !allowedSubRoles.includes(user.sub_role)) {
    return <Navigate to="/401" />;
  }

  return children;
};
